import classNames from 'classnames';
import styles from './SocialLinks.module.scss';
import { Link, Icon } from 'ui/components';
import LinkedInIcon from 'ui/icons/icon-linkedin.svg';
import FacebookIcon from 'ui/icons/icon-facebook.svg';
import YouTubeIcon from 'ui/icons/icon-youtube.svg';
import ChinaIcon from 'ui/icons/icon_china_some.svg';

export interface SocialLinksProps {
	className?: string;
	SocialLinksItems?: Umbraco.SocialLink[];
	iconType?: string;
	chineseCulture?: boolean;
}

const icon = (iconType: string) => {
	switch (iconType) {
		case 'LinkedIn': {
			return <LinkedInIcon />;
		}
		case 'Facebook': {
			return <FacebookIcon />;
		}
		case 'YouTube': {
			return <YouTubeIcon />;
		}
		default: {
			return <YouTubeIcon />;
		}
	}
};

export const SocialLinks: React.FC<SocialLinksProps> = ({ className, SocialLinksItems, chineseCulture }) => {
	return (
		<ul className={classNames(styles.SocialLinks, className)}>
			{SocialLinksItems?.map((SocialLinksItem: Umbraco.SocialLink, index) => {
				const { socialLinkUrl, socialLinkType } = SocialLinksItem?.content?.properties ?? {};

				if (chineseCulture) {
					if (socialLinkType !== 'LinkedIn' && socialLinkType !== 'WeChat') return null;
				} else if (socialLinkType === 'WeChat') {
					return null;
				}

				return (
					<li key={index} className={styles.SocialLinks_item}>
						<Link className={styles.SocialLinks_link} url={socialLinkUrl?.url ?? ''} ariaLabel={socialLinkType}>
							<Icon size="lg">
								{socialLinkType === 'WeChat' ? <ChinaIcon className={styles.SocialLinks_icon___china} /> : icon(socialLinkType)}
							</Icon>
						</Link>
					</li>
				);
			})}
		</ul>
	);
};
